export default __webpack_public_path__ + "static/media/promos-icon.3f3d5d45.webp";